/**
 * The global axios interceptor (src/contexts/User.jsx) RESOLVES a request that
 * failed with a 5xx or never reached the server — it has already told the user,
 * so it hands the caller `undefined` instead of rejecting. A caller that then
 * reads `res.data` throws a TypeError (or, with `res?.data ?? []`, shows an
 * empty list as if it were real).
 *
 * `requireResponse(res)` turns that `undefined` back into a thrown error, so the
 * caller's existing catch / error state runs. It changes nothing for a real
 * response. The interceptor itself is deliberately left alone: ~250 call sites
 * rely on today's swallow-and-notify behaviour.
 */
import { markErrorReported } from "./reported.js";

export class NoResponseError extends Error {
  constructor(message = "The request did not complete.") {
    super(message);
    this.name = "NoResponseError";
    // The interceptor already notified the user and recorded the underlying
    // failure, so the global unhandled-rejection net must not report it again.
    markErrorReported(this);
  }
}

export function requireResponse(res, message) {
  if (res === undefined || res === null) {
    throw new NoResponseError(message);
  }
  return res;
}

export function isNoResponseError(error) {
  return error instanceof NoResponseError;
}
